import { useEffect, useState } from "react";


export function useFirstCategory(categoryArray) {
  const [category, setCategory] = useState(null);

	useEffect(() => {
		if (categoryArray) {
			for (const tempCategory of categoryArray) {
				if (tempCategory.name.toLowerCase() !== 'uncategorized') {
					setCategory(tempCategory);
					break;
				}
			}
		}
	}, [categoryArray]);

  return category;
}
